import React from 'react';
import Header from '../../components/Header/Header';
import './Page404.styles.scss';

function Page404() {
  return (
    <>

      <Header />
      <div className="page404">
        <span className="title">Hummm que tenemos aqui... parece que nada... Page404</span>
      </div>
    </>
  );
}

export default Page404;
